module.exports = __webpack_public_path__ + "static/media/Ball-pattern.cd08855e.png";